/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
import { isTrue, isUndefined, MapCreate } from '../shared/utils';

const { assignedNodes: assignedNodesOriginal, assignedElements: assignedElementsOriginal } = HTMLSlotElement.prototype;

const assignedElementsDistortion = function assignedElements(
  this: HTMLSlotElement,
  options?: AssignedNodesOptions
): Element[] {
  const flatten = !isUndefined(options) && isTrue(options.flatten);
  if (!flatten) {
    return [];
  }
  return assignedElementsOriginal.call(this, { flatten: true });
};

const assignedNodesDistortion = function assignedNodes(this: HTMLSlotElement, options?: AssignedNodesOptions): Node[] {
  const flatten = !isUndefined(options) && isTrue(options.flatten);
  if (!flatten) {
    return [];
  }
  return assignedNodesOriginal.call(this, { flatten: true });
};

export default MapCreate([
  [assignedElementsOriginal, assignedElementsDistortion],
  [assignedNodesOriginal, assignedNodesDistortion],
]);
